import type { LiveTradeAmendRequest, LiveTradeResponse } from 'apiConnector/secondary-market/live/models';
import { secondaryMarketAmendActionsFactory } from 'state/secondaryMarket/shared/amend/amend.actions';

export const liveAmendActions = secondaryMarketAmendActionsFactory<LiveTradeAmendRequest, LiveTradeResponse, 'LIVE'>(
  'LIVE',
);

type TypeofLiveAmendActions = typeof liveAmendActions;
export type SecondaryMarketLiveAmendRequested = ReturnType<TypeofLiveAmendActions['secondaryMarketAmendRequested']>;
export type SecondaryMarketLiveAmendReceived = ReturnType<TypeofLiveAmendActions['secondaryMarketAmendReceived']>;
export type SecondaryMarketLiveAmendFailed = ReturnType<TypeofLiveAmendActions['secondaryMarketAmendFailed']>;
export type SecondaryMarketLiveAmendRejected = ReturnType<TypeofLiveAmendActions['secondaryMarketAmendRejected']>;
export type SecondaryMarketLiveAmendCollided = ReturnType<TypeofLiveAmendActions['secondaryMarketAmendCollided']>;

export type SecondaryMarketLiveAmendActions = ReturnType<TypeofLiveAmendActions[keyof TypeofLiveAmendActions]>;
